export const STORY_WIDTH = {
  xl: { width: "27vw", height: "48vw" },
  lg: { width: "405px", height: "720px" },
  md: { width: "405px", height: "720px" },
  sm: { width: "405px", height: "720px" },
  xs: { width: "90vw", height: "80vh" },
};
